import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import ConfirmationSuccessWithoutKyc from '@olxeu-a2b/ui/src/pages/order-confirmation/components/ConfirmationSuccessWithoutKyc';
import MarketPayConfirmationSuccess from '@olxeu-a2b/ui/src/pages/order-confirmation/components/MarketPayConfirmationSuccess';
import { useTrackEvent, useTrackPage } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import { getConfig } from '@olxeu-a2b/delivery-utils/src/extras';
import { useFeatureFlag } from '@olx/react-laquesis';
import { KycAction } from '@olxeu-a2b/core/typings';
import Loader from '@olxeu-a2b/ui/src/commons/components/Loader';
import { useGetKYC } from '@olxeu-a2b/delivery-utils/src/hooks';
import ViewportContext from '../../../contexts/ViewportContext';

import S from './style';
import { usePspLogicForKyc } from '../hooks/usePspLogicForKyc';

const tracking = (key: TemplateStringsArray) => `delivery_seller_confirmation_success_page${key}`;
const {
  deliveryPaths: { ordersSelling, desktopOrders, desktopVerification, verification },
  sites,
} = getConfig();

export default ({ offerId }: { offerId: string }) => {
  const [backToOverview, setBackToOverview] = useState(false);
  const { desktop } = useContext(ViewportContext);
  const trackEvent = useTrackEvent();
  const [getKYC, kycStatus, kycStatusLoading] = useGetKYC();
  const statusRequired: KycAction = 'KYC_REQUIRED';
  const { isSellerOnPayuTierTwo, isLoading } = usePspLogicForKyc(true);

  useTrackPage(tracking``);
  const kycDisabledRedirectUrl = desktop
    ? `${sites.desktop.url}${desktopVerification}`
    : `${sites.delivery.url}${verification}`;
  useEffect(() => {
    getKYC();
  }, []);

  const isKycSectionDisabled = useFeatureFlag('mkp-2632');
  if (backToOverview) {
    return <Redirect to={`${ordersSelling}/${offerId}`} />;
  }

  if (isLoading || kycStatusLoading) {
    return <Loader />;
  }

  return (
    <S.Wrapper data-cy="confirmation-success-page" className="confirmation-success">
      {isKycSectionDisabled && !isSellerOnPayuTierTwo && kycStatus?.kycAction === statusRequired ? (
        <ConfirmationSuccessWithoutKyc desktop={desktop} buttonUrl={kycDisabledRedirectUrl} />
      ) : (
        <MarketPayConfirmationSuccess
          desktop={desktop}
          buttonUrl={`${sites.desktop.url}${desktopOrders}`}
          onClick={() => {
            trackEvent(tracking`_click`);
            setBackToOverview(true);
          }}
        />
      )}
    </S.Wrapper>
  );
};
